import store from "../store";
import { APIService } from "./api";
const apiService = new APIService();
// const API_URL = 'http://localhost:8000';

export class APIServiceUser {
  // createUser (data) {
  //   var config = {
  //     url: '/property',
  //     method: 'post',
  //     headers: {'x-access-token': store.getters.token,
  //       'content-type': 'application/json'},
  //     data: data
  //   };
  //   return axios(config)
  //     .then(response => response.data)
  //     .catch(e => {
  //       if ((e.response.data) && e.response.data.message === 'Token is invalid!') {
  //         store.commit('resetState');
  //         router.push('/console/login');
  //       }
  //       throw e;
  //     });
  // }

  createUserAdditional(data) {
    var config = {
      url: "/users",
      method: "post",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }

  // editUser (data) {
  //   var config = {
  //     url: '/property/' + data.id,
  //     method: 'put',
  //     headers: {'x-access-token': store.getters.token,
  //       'content-type': 'application/json'},
  //     data: data
  //   };
  //   return axios(config)
  //     .then(response => response.data)
  //     .catch(e => {
  //       if ((e.response.data) && e.response.data.message === 'Token is invalid!') {
  //         store.commit('resetState');
  //         router.push('/console/login');
  //       } else if (e.response.data.message === 'Could not find property') {
  //         router.push('/console/unauthorized');
  //       }
  //       throw e;
  //     });
  // }

  // getUser (propertyID) {
  //   var config = {
  //     url: '/property/' + propertyID,
  //     method: 'get',
  //     headers: {'x-access-token': store.getters.token,
  //       'content-type': 'application/json'}
  //   };
  //   return axios(config)
  //     .then(response => response.data)
  //     .catch(e => {
  //       if ((e.response.data) && e.response.data.message === 'Token is invalid!') {
  //         store.commit('resetState');
  //         router.push('/console/login');
  //       } else if (e.response.data.message === 'Could not find property') {
  //         router.push('/console/unauthorized');
  //       }
  //       throw e;
  //     });
  // }

  getUsers() {
    var config = {
      url: "/users",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  deleteUser(userID) {
    var config = {
      url: "/user/" + userID,
      method: "delete",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  createUserPassword(data) {
    var config = {
      url: "/user/createpassword",
      method: "put",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }

  resendUserPasswordCreateLink(data) {
    var config = {
      url: "/users/resend",
      method: "put",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }

  changePassword(data) {
    var config = {
      url: "/user/password",
      method: "put",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }

  resetPassword(data) {
    var config = {
      url: "/resetpassword",
      method: "post",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }
}
